import { render, staticRenderFns } from "./ViewOrderPending.vue?vue&type=template&id=63522230&scoped=true"
import script from "./ViewOrderPending.vue?vue&type=script&lang=ts"
export * from "./ViewOrderPending.vue?vue&type=script&lang=ts"
import style0 from "./ViewOrderPending.vue?vue&type=style&index=0&id=63522230&prod&lang=scss&scoped=true"
import style1 from "./ViewOrderPending.vue?vue&type=style&index=1&id=63522230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63522230",
  null
  
)

export default component.exports